var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStreams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 205,
    height: 122,
    viewBox: "0 0 205 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "db_empty1-a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.956863 0 0 0 0 0.968627 0 0 0 0 0.984314 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(26 7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FB",
    d: "M12.819426,-5.17920154e-16 L140.180574,5.17920154e-16 C144.638168,-3.00926524e-16 146.254599,0.464128056 147.884229,1.33566352 C149.513858,2.20719898 150.792801,3.48614185 151.664336,5.11577148 C152.535872,6.74540111 153,8.3618323 153,12.819426 L153,95.180574 C153,99.6381677 152.535872,101.254599 151.664336,102.884229 C150.792801,104.513858 149.513858,105.792801 147.884229,106.664336 C146.254599,107.535872 144.638168,108 140.180574,108 L12.819426,108 C8.3618323,108 6.74540111,107.535872 5.11577148,106.664336 C3.48614185,105.792801 2.20719898,104.513858 1.33566352,102.884229 C0.464128056,101.254599 2.00617683e-16,99.6381677 -3.45280103e-16,95.180574 L3.45280103e-16,12.819426 C-2.00617683e-16,8.3618323 0.464128056,6.74540111 1.33566352,5.11577148 C2.20719898,3.48614185 3.48614185,2.20719898 5.11577148,1.33566352 C6.74540111,0.464128056 8.3618323,3.00926524e-16 12.819426,-5.17920154e-16 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 29)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9E0",
    d: "M7.6916556,-1.60182868e-13 L82.3083444,-1.59561363e-13 C84.9829006,-1.60052671e-13 85.9527593,0.278476833 86.9305371,0.801398111 C87.9083149,1.32431939 88.6756806,2.09168511 89.1986019,3.06946289 C89.7215232,4.04724067 90,5.01709938 90,7.6916556 L90,46.3083444 C90,48.9829006 89.7215232,49.9527593 89.1986019,50.9305371 C88.6756806,51.9083149 87.9083149,52.6756806 86.9305371,53.1986019 C85.9527593,53.7215232 84.9829006,54 82.3083444,54 L7.6916556,54 C5.01709938,54 4.04724067,53.7215232 3.06946289,53.1986019 C2.09168511,52.6756806 1.32431939,51.9083149 0.801398111,50.9305371 C0.278476833,49.9527593 -7.80393303e-14,48.9829006 -7.8366869e-14,46.3083444 L-7.79525329e-14,7.6916556 C-7.82800715e-14,5.01709938 0.278476833,4.04724067 0.801398111,3.06946289 C1.32431939,2.09168511 2.09168511,1.32431939 3.06946289,0.801398111 C4.04724067,0.278476833 5.01709938,-1.5969156e-13 7.6916556,-1.60182868e-13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EDF1F5",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M8,27.75 C16.2871742,27.7423149 15.0184598,34 22,34 C28.6148146,34 31.9267895,25.6371355 41,25.25 C49.6981323,25.6371355 49.7157885,30.2790698 59,30.25 C68.4434954,30.3049096 71.7681928,14 82,14"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9E0",
    d: "M14.6916556,29 L44.3083444,29 C46.9829006,29 47.9527593,29.2784768 48.9305371,29.8013981 C49.9083149,30.3243194 50.6756806,31.0916851 51.1986019,32.0694629 C51.7215232,33.0472407 52,34.0170994 52,36.6916556 L52,93.3083444 C52,95.9829006 51.7215232,96.9527593 51.1986019,97.9305371 C50.6756806,98.9083149 49.9083149,99.6756806 48.9305371,100.198602 C47.9527593,100.721523 46.9829006,101 44.3083444,101 L14.6916556,101 C12.0170994,101 11.0472407,100.721523 10.0694629,100.198602 C9.09168511,99.6756806 8.32431939,98.9083149 7.80139811,97.9305371 C7.27847683,96.9527593 7,95.9829006 7,93.3083444 L7,36.6916556 C7,34.0170994 7.27847683,33.0472407 7.80139811,32.0694629 C8.32431939,31.0916851 9.09168511,30.3243194 10.0694629,29.8013981 C11.0472407,29.2784768 12.0170994,29 14.6916556,29 Z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#db_empty1-a)",
    opacity: 0.797
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9F0",
    d: "M13.0929204,0.784629767 C19.9964797,0.784629767 25.5929204,6.38107039 25.5929204,13.2846298 C25.5929204,20.1881891 19.9964797,25.7846298 13.0929204,25.7846298 C6.18936098,25.7846298 0.592920354,20.1881891 0.592920354,13.2846298 C0.592920354,6.38107039 6.18936098,0.784629767 13.0929204,0.784629767 Z M13.0929204,5.78462977 C8.95078473,5.78462977 5.59292035,9.14249414 5.59292035,13.2846298 C5.59292035,17.4267654 8.95078473,20.7846298 13.0929204,20.7846298 C17.235056,20.7846298 20.5929204,17.4267654 20.5929204,13.2846298 C20.5929204,9.14249414 17.235056,5.78462977 13.0929204,5.78462977 Z",
    transform: "translate(16.407 35.215)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 10,
    x: 14,
    y: 84,
    fill: "#EDF1F5",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 22,
    y: 82,
    fill: "#EDF1F5",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 15,
    x: 30,
    y: 79,
    fill: "#EDF1F5",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 21,
    x: 38,
    y: 73,
    fill: "#EDF1F5",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 7,
    x: 7,
    y: 18,
    fill: "#D4D9E0",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 7,
    x: 7,
    y: 7,
    fill: "#D4D9E0",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 7,
    x: 40,
    y: 7,
    fill: "#D4D9E0",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 7,
    x: 65,
    y: 7,
    fill: "#D4D9E0",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 5,
    x: 56,
    y: 87,
    fill: "#D4D9E0",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 5,
    x: 56,
    y: 96,
    fill: "#D4D9E0",
    rx: 2.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStreams);
export default __webpack_public_path__ + "static/media/empty-streams.78a6a8ae.svg";
export { ForwardRef as ReactComponent };